import { render } from "./DetailsOffre.vue?vue&type=template&id=6c245894"
import script from "./DetailsOffre.vue?vue&type=script&lang=js"
export * from "./DetailsOffre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__